module.exports = __webpack_public_path__ + "img/thankyou.3f463e8e.png";